import React, { useEffect, useState } from 'react';
import Spinner from '../shared/Spinner';
import { useScorecardLive } from './useScorecardLive';

export default function ScorecardCard({ demo, endpoints, polling, onScorecard, onToast }) {
    useScorecardLive({ demo, endpoints, polling, onScorecard });

    const isPending = demo.scorecard.status === 'requested';
    const [pollingGaveUp, setPollingGaveUp] = useState(false);

    // Mirrors the hook's maxMs cutoff, which it does not expose: past it the page
    // is no longer waiting on anything, so the spinner must stop.
    useEffect(() => {
        setPollingGaveUp(false);
        if (!isPending) {
            return undefined;
        }
        const timer = setTimeout(() => setPollingGaveUp(true), polling.maxMs);
        return () => clearTimeout(timer);
    }, [demo.id, isPending, polling.maxMs]);

    const showSpinner = isPending && !pollingGaveUp;

    const handleCopy = () => {
        navigator.clipboard.writeText(demo.scorecard.url).then(
            () => onToast({ type: 'success', text: __('Link copied') }),
            () => onToast({ type: 'error', text: __('Could not copy the link') }),
        );
    };

    return (
        <div data-testid="demo-edit-scorecard">
            {demo.scorecard.status === 'done' ? (
                <>
                    <a
                        href={demo.scorecard.url}
                        target="_blank"
                        rel="noopener"
                        className="btn btn-link btn-block d-flex align-items-center justify-content-between px-0"
                    >
                        {__('View Reputation Scorecard')}
                        <i className="fas fa-external-link-alt" aria-hidden="true" />
                    </a>
                    <button
                        type="button"
                        className="btn btn-link btn-block d-flex align-items-center justify-content-between px-0"
                        onClick={handleCopy}
                    >
                        {__('Copy Link')}
                        <i className="fas fa-clone" aria-hidden="true" />
                    </button>
                </>
            ) : (
                <p data-testid="demo-edit-scorecard-pending">
                    {showSpinner && <Spinner label={__('Waiting for the scorecard')} className="mr-2" />}
                    {__('Generating reputation scorecard…')}
                </p>
            )}
        </div>
    );
}
